import { StyleSheet } from 'aphrodite/no-important';
import { children, media } from 'util/style-variables';
import * as models from '../../models';

export const style: any = (styles: models.base.IGenericObject) =>
  StyleSheet.create({
    langSelector: {
      width: 90,
      background: '#fffef6',
      color: '#000',
      cursor: 'pointer',
      position: 'relative',
      ...styles.selector,

      [children('svg')]: {
        fill: styles.selector.color
      },

      [media.desktop]: {
        ':hover': {
          [children('.dropdown-down-icon')]: {
            transform: 'rotate(180deg) translateY(-2px)'
          }
        }
      }
    },

    langTrigger: {
      cursor: 'pointer',
      position: 'absolute',
      width: '100%',
      height: '100%',

      ':checked + #dropdown': {
        display: 'block'
      },

      [media.desktop]: {
        ':hover + #dropdown': {
          display: 'block'
        }
      }
    },

    langLabel: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 6,
    },

    langDropdown: {
      position: 'absolute',
      width: '100%',
      display: 'none',
      zIndex: 3,

      [media.desktop]: {
        ':hover': {
          display: 'block'
        }
      },

      [children('p')]: {
        background: '#e5e8e9',
        color: '#000',
        padding: 6,
        ...styles.dropdown,

        [media.desktop]: {
          ':hover': {
            background: '#646464',
            color: '#fff',
            ...styles.dropdownHover
          }
        }
      }
    }
  });
